import axiosInstance from "../../configs/axios.config";
const SERVER = import.meta.env.VITE_API_URL;

/**
 * Get customers with financial details for the finance/account module
 * @param {number} page - Current page number
 * @param {number} limit - Items per page
 * @param {string} search - Search query
 * @param {string} type - Customer type filter (Individual/Corporate)
 */
export const getCustomersFinance = async (page = 1, limit = 10, search = "", type = "") => {
  try {
    let url = `${SERVER}/finance/customers?page=${page}&limit=${limit}`;
    
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (type) url += `&type=${type}`;

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers finance:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

/**
 * Get detailed financial information for a specific customer
 * @param {string} customerId - Customer ID
 */
export const getCustomerFinanceDetails = async (customerId) => {
  try {
    const response = await axiosInstance.get(
      `${SERVER}/finance/customers/${customerId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching customer finance details:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

/**
 * Get financial statistics summary
 */
export const getFinanceStatistics = async () => {
  try {
    const response = await axiosInstance.get(`${SERVER}/finance/statistics`);
    return response.data;
  } catch (error) {
    console.error("Error fetching finance statistics:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

/**
 * Get paginated bookings for a specific customer
 * @param {string} customerId - Customer ID
 * @param {number} page - Page number
 * @param {number} limit - Items per page
 */
export const getCustomerBookings = async (customerId, page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `${SERVER}/finance/customers/${customerId}/bookings?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching customer bookings:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

/**
 * Get paginated payments for a specific customer
 * @param {string} customerId - Customer ID
 * @param {number} page - Page number
 * @param {number} limit - Items per page
 */
export const getCustomerPayments = async (customerId, page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `${SERVER}/finance/customers/${customerId}/payments?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching customer payments:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};
